import StayStudyPage from "../components/StayStudyPage";

export default function Stay9() {
  return (
    <StayStudyPage
      className="Class 9"
      heroTitle="Class 9 Stay & Study Program"
      heroDescription="An intensive residential academic program focused on concept mastery and board exam preparation."

      section1={{
        title: "📘 Strong Board Exam Foundation",
        description:
          "Class 9 is the backbone of Class 10 success. Our program ensures deep concept mastery.",
        points: [
          "Strictly STATE|CBSE-based syllabus coverage",
          "Advanced focus on Maths & Science",
          "Concept clarity with numerical problem solving",
          "Regular tests, revisions & assessments",
          "Early preparation for Class 10 boards"
        ]
      }}

      section2={{
        title: "🗓️ Disciplined Exam-Oriented Routine",
        description:
          "A rigorous daily routine designed to improve performance and consistency.",
        points: [
          "Long supervised study hours",
          "Daily revision & doubt-clearing",
          "Answer writing and exam practice",
          "Time management & stress handling",
          "Highly focused academic environment"
        ]
      }}

      whyUs={{
        title: "⭐ Why Choose ACCESS Stay & Study for Class 9?",
        description:
          "We provide a strong academic and residential ecosystem for board-level success.",
        points: [
          "Highly experienced board exam faculty",
          "24/7 monitored residential campus",
          "Daily supervised study sessions",
          "Weekly tests & detailed analysis",
          "One-on-one academic mentoring",
          "Nutritious food & safe hostel facilities",
          "Strong focus on discipline and results"
        ]
      }}

      images={{
        section1: "/images/class9-1.jpg",
        section2: "/images/class9-2.jpg",
        whyUs: "/images/Hostel2.jpeg"
      }}

      fee="80,000"
      whatsappText="Hello ACCESS Team, I would like to enquire about the Class 9 Stay & Study Program."
    />
  );
}
